import React, { useEffect, useState } from "react";
import { Plus, Search, Trash2, Edit2 } from "lucide-react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import axios from "axios";
import ApiUrl from "../Environment/ApiUrl";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const Productcategory = () => {
  const navigate = useNavigate();
  const [addpopup, setAddpopup] = useState(false);
  const [updatepopup, setUpdatepopup] = useState(false);
  const [deleteShowModal, setDeleteShowModal] = useState(false);
  const [productcategorytabledata, setProductcategorytabledata] = useState([]);

  const [productcategorydata, setProductcategorydata] = useState({
    Category: "",
    SubCategory: "",
  });

  // For update
  const [updateData, setUpdateData] = useState({
    Category: "",
    SubCategory: "",
  });
  const [updateId, setUpdateId] = useState("");

  // For delete
  const [deleteId, setDeleteId] = useState("");
  const [deleteName, setDeleteName] = useState("");

  // Search and pagination
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(7);

  useEffect(() => {
    fetchdata();
  }, []);

  const fetchdata = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/product_category.php`);
      console.log("response data is working", response.data);

      if (response.data && response.data.data) {
        setProductcategorytabledata(response.data.data);
      } else {
        setProductcategorytabledata([]);
      }
    } catch (error) {
      console.log("fetch data is error", error);
      toast.error("Failed to fetch");
      setProductcategorytabledata([]);
    }
  };

  const handleproductcategorysubmit = async (e) => {
    e.preventDefault();
    try {
      const formdata = {
        Category: productcategorydata.Category,
        SubCategory: productcategorydata.SubCategory,
      };
      const response = await axios.post(
        `${ApiUrl}/product_category.php`,
        formdata
      );

      toast.success("Product category added successfully!");
      setProductcategorydata({
        Category: "",
        SubCategory: "",
      });
      fetchdata();
      setAddpopup(false);
    } catch (error) {
      console.log("handleproductcategorysubmit data is error", error);
    }
  };

  // Update functions
  const handleUpdate = (id, data) => {
    setUpdatepopup(true);
    setUpdateId(id);
    setUpdateData({
      Category: data.Category,
      SubCategory: data.SubCategory,
    });
  };

  const handleUpdateSubmit = async (e) => {
    e.preventDefault();
    try {
      const formdata = {
        Category: updateData.Category,
        SubCategory: updateData.SubCategory,
      };
      const response = await axios.put(
        `${ApiUrl}/product_category.php/${updateId}`,
        formdata
      );
        toast.success("Product category updated successfully!");
      console.log("update response", response);
      setUpdatepopup(false);
      fetchdata();
    } catch (error) {
      console.log("update error", error);
    }
  };

  // Delete functions
  const handleDeleteModal = (id, Category) => {
    setDeleteId(id);
    setDeleteName(Category);
    setDeleteShowModal(true);
  };

  const handleDelete = async () => {
    try {
      const response = await axios.delete(
        `${ApiUrl}/product_category.php/${deleteId}`
      );
      toast.success(`Product category ${deleteName} deleted successfully!`);

      console.log("delete response", response);
      setDeleteShowModal(false);
      fetchdata();
    } catch (error) {
      console.log("delete error", error);
    }
  };

  // Search and pagination logic
  const filteredData = productcategorytabledata.filter((item) =>
    Object.values(item)
      .join(" ")
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = filteredData.slice(startIndex, startIndex + itemsPerPage);

  return (
    <div className="bg-white font-sans">
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} closeOnClick pauseOnHover />
      {/* Header */}
      <div className="p-3 p-md-4 bg-white">
        <div className="d-flex justify-content-between align-items-center flex-wrap">
          <div className="d-flex gap-3 align-items-center">

            <h2 className="m-0 fs-5 fw-semibold text-dark">Product Category</h2>
            <button
              className="btn btn-danger d-flex align-items-center gap-2 btn-sm-sm"
              onClick={() => setAddpopup(true)}
            >
              <Plus size={18} />
              Add Category
            </button>
          </div>
          <button
            className="btn btn-secondary"
            onClick={() => navigate("/products")}
          >Back</button>



        </div>
      </div>

      {/* Card */}
      <div className="card mx-3 mx-md-4 border mb-5">
        {/* Controls Row */}
        <div className="card-header bg-white d-flex justify-content-between align-items-center p-3 border-bottom">
          {/* Show All Dropdown */}
          <div
            className="d-flex align-items-center gap-2 "
            style={{ height: "36px", width: "120px" }}
          >
            <div
              className="d-flex align-items-center justify-content-center"
              style={{ height: "28px", width: "14px" }}
            >
              <svg width="14" height="14" viewBox="0 0 12 12" fill="none">
                <rect x="1" y="1" width="3" height="3" fill="#666" />
                <rect x="1" y="5" width="3" height="3" fill="#666" />
                <rect x="1" y="9" width="3" height="2" fill="#666" />
                <rect x="5" y="1" width="6" height="1" fill="#666" />
                <rect x="5" y="3" width="6" height="1" fill="#666" />
                <rect x="5" y="5" width="6" height="1" fill="#666" />
                <rect x="5" y="7" width="6" height="1" fill="#666" />
                <rect x="5" y="9" width="6" height="1" fill="#666" />
              </svg>
            </div>
            <select
              className="border-0 bg-transparent text-dark form-select form-select-sm"
              style={{
                boxShadow: "none",
                outline: "none",
                lineHeight: "1.1",
                height: "28px",
                cursor: "pointer",
                width: "80px",
                paddingTop: "0",
                paddingBottom: "0",
              }}
              value={itemsPerPage}
              onChange={(e) => {
                setItemsPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
            >
              <option value="5">Show 5</option>
              <option value="10">Show 10</option>
              <option value="25">Show 25</option>
            </select>
          </div>

          {/* Search */}
          <div className="position-relative" style={{ width: "280px" }}>
            <input
              type="text"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-100 ps-3 pe-5 py-2 border rounded form-control"
            />
            <Search
              size={18}
              className="position-absolute top-50 end-0 translate-middle-y me-3 text-danger"
              style={{ pointerEvents: "none" }}
            />
          </div>
        </div>

        {/* Table Container */}
        <div className="card-body p-0">
          {/* Table */}
          <div className="table-responsive">
            <table className="table table-hover mb-0 text-center">
              <thead>
                <tr>
                  <th
                    style={{ backgroundColor: "#d3d3d3" }}
                    className=" p-3  fw-semibold small "
                  >
                    S.No
                  </th>
                  <th
                    style={{ backgroundColor: "#d3d3d3" }}
                    className=" p-3  fw-semibold small "
                  >
                    Category
                  </th>
                  <th
                    style={{ backgroundColor: "#d3d3d3" }}
                    className=" p-3  fw-semibold small "
                  >
                    SubCategory
                  </th>
                  <th
                    style={{ backgroundColor: "#d3d3d3" }}
                    className=" p-3  fw-semibold small "
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentItems.length > 0 ? (
                  currentItems.map((item, index) => (
                    <tr key={index} style={{ fontSize: "14px" }}>
                      <td>{startIndex + index + 1}</td>
                      <td>{item.Category}</td>
                      <td>{item.SubCategory}</td>
                      <td>
                        <div className="d-flex justify-content-center">
                          <button
                            onClick={() =>
                              handleDeleteModal(item.id, item.Category)
                            }
                            className="p-1 border-0 bg-transparent cursor-pointer text-muted"
                          >
                            <Trash2 size={16} />
                          </button>
                          <button
                            onClick={() => handleUpdate(item.id, item)}
                            className="p-1 border-0 bg-transparent cursor-pointer text-muted"
                          >
                            <Edit2 size={16} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center p-5">
                      No data available.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

         {/* Pagination */}
{itemsPerPage < filteredData.length && (
  <div className="card-footer bg-white d-flex justify-content-between align-items-center border-top">
    {/* Previous */}
    <button
      onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
      disabled={currentPage === 1}
      className={`btn btn-sm d-flex align-items-center gap-2 ${
        currentPage === 1 ? "bg-light text-muted" : "bg-white text-dark"
      }`}
    >
      <FaChevronLeft size={14} />
      <span className="ms-1 d-none d-md-inline">Previous</span>
    </button>

    {/* Page Numbers */}
    <div className="d-flex gap-1">
      {[1, 2, 3, 4,].map((pageNum) => (
        <button
          key={pageNum}
          onClick={() => setCurrentPage(pageNum)}
          className={`btn btn-sm ${
            currentPage === pageNum
              ? "bg-danger bg-opacity-10 text-danger"
              : "bg-white text-dark"
          }`}
        >
          {pageNum}
        </button>
      ))}

      {/* Ellipsis */}
      {totalPages > 4 && (
        <span className="px-2 py-1">...</span>
      )}

      {/* Last Page */}
      <button
        onClick={() => setCurrentPage(totalPages)}
        className={`btn btn-sm ${
          currentPage === totalPages
            ? "bg-danger bg-opacity-10 text-danger"
            : "bg-white text-dark"
        }`}
      >
        {totalPages}
      </button>
    </div>

    {/* Next */}
    <button
      onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
      disabled={currentPage === totalPages}
      className={`btn btn-sm d-flex align-items-center gap-2 ${
        currentPage === totalPages
          ? "bg-light text-muted"
          : "bg-white text-dark"
      }`}
    >
      <span className="ms-1 d-none d-md-inline">Next</span>
      <FaChevronRight size={14} />
    </button>
  </div>
)}


        </div>
      </div>

      {/* Add Modal */}
      <div
        className={`modal fade ${addpopup ? "show" : ""}`}
        style={{
          display: addpopup ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
        tabIndex="-1"
        aria-labelledby="addCustomerModalLabel"
        aria-hidden={!addpopup}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div
            className="modal-content rounded"
            style={{ backgroundColor: " rgb(255, 240, 245)" }}
          >
            <div className="modal-header bg-pink-light border-bottom-0">
              <h5 className="modal-title m-0  fw-semibold">Add Category</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setAddpopup(false)}
              ></button>
            </div>

            <div className="modal-body bg-pink-light">
              <div className="row g-3">
                <div className="col-md-12">
                  <label className="form-label small fw-medium">
                    Category <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="Category"
                    value={productcategorydata.Category}
                    onChange={(e) =>
                      setProductcategorydata({
                        ...productcategorydata,
                        Category: e.target.value,
                      })
                    }
                    placeholder="Enter Category"
                  />
                </div>
                <div className="col-md-12">
                  <label className="form-label small fw-medium">
                    SubCategory <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="SubCategory"
                    value={productcategorydata.SubCategory}
                    onChange={(e) =>
                      setProductcategorydata({
                        ...productcategorydata,
                        SubCategory: e.target.value,
                      })
                    }
                    placeholder="Enter SubCategory"
                  />
                </div>
              </div>
            </div>

            <div className="modal-footer border-top-0">
              <button
                type="button"
                className="btn btn-sm btn-danger"
                onClick={() => setAddpopup(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-sm btn-success"
                onClick={handleproductcategorysubmit}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Update Modal */}
      <div
        className={`modal fade ${updatepopup ? "show" : ""}`}
        style={{
          display: updatepopup ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
        tabIndex="-1"
        aria-labelledby="addCustomerModalLabel"
        aria-hidden={!updatepopup}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div
            className="modal-content rounded"
            style={{ backgroundColor: " rgb(255, 240, 245)" }}
          >
            <div className="modal-header bg-pink-light border-bottom-0">
              <h5 className="modal-title m-0  fw-semibold">Update Category</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setUpdatepopup(false)}
              ></button>
            </div>

            <div className="modal-body bg-pink-light">
              <div className="row g-3">
                <div className="col-md-12">
                  <label className="form-label small fw-medium">
                    Category <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="Category"
                    value={updateData.Category}
                    onChange={(e) =>
                      setUpdateData({
                        ...updateData,
                        Category: e.target.value,
                      })
                    }
                    placeholder="Enter Category"
                  />
                </div>
                <div className="col-md-12">
                  <label className="form-label small fw-medium">
                    SubCategory <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="SubCategory"
                    value={updateData.SubCategory}
                    onChange={(e) =>
                      setUpdateData({
                        ...updateData,
                        SubCategory: e.target.value,
                      })
                    }
                    placeholder="Enter SubCategory"
                  />
                </div>
              </div>
            </div>

            <div className="modal-footer border-top-0">
              <button
                type="button"
                className="btn btn-sm btn-danger"
                onClick={() => setUpdatepopup(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-sm btn-success"
                onClick={handleUpdateSubmit}
              >
                Update
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Delete Modal */}
      <div
        className={`modal fade ${deleteShowModal ? "show" : ""}`}
        style={{
          display: deleteShowModal ? "block" : "none",
          backgroundColor: "rgba(0,0,0,0.5)",
        }}
        tabIndex="-1"
        aria-labelledby="deleteConfirmModalLabel"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-confirm">
          <div className="modal-content">
            <div className="modal-body text-center">
              <div className="d-flex justify-content-center mb-3">
                <div
                  className="icon-box bg-light rounded-circle d-flex align-items-center justify-content-center"
                  style={{ width: "80px", height: "80px" }}
                >
                  <i className="bi bi-exclamation-triangle text-danger fs-2"></i>
                </div>
              </div>
              <h4 className="modal-title mb-3">Are you sure?</h4>
              <h6 className="mb-4">
                Do you really want to delete this{" "}
                <span className="text-primary">({deleteName}</span>
                )?
              </h6>
              <div className="d-flex btn-group">
                <button
                  type="button"
                  className="btn btn-secondary btn-sm flex-grow-1"
                  onClick={() => setDeleteShowModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger btn-sm flex-grow-1 mx-2"
                  onClick={handleDelete}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Productcategory;